'use client'

import { useGlobalLoading } from '@/contexts/GlobalLoadingContext'
import { motion, AnimatePresence } from 'framer-motion'

export default function GlobalLoadingIndicator() {
    const { isLoading, message } = useGlobalLoading()

    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="fixed top-0 left-0 right-0 z-[100] bg-blue-600 text-white shadow-lg"
                >
                    <div className="flex items-center justify-center px-4 py-3">
                        <div className="flex items-center gap-3">
                            <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                            <span className="text-sm font-medium">
                                {message || 'Loading...'}
                            </span>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}












